function setDate() {
  const date = new Date();
  const hours =
    date.getHours().toString().length === 1
      ? "0" + date.getHours().toString()
      : date.getHours();
  const minutes =
    date.getMinutes().toString().length === 1
      ? "0" + date.getMinutes().toString()
      : date.getMinutes();
  const strday = date.toLocaleDateString("en-EN", { weekday: "long" });
  let element = document.getElementById("date");
  element.textContent = `${strday} ${hours}:${minutes}`;
}

function getLocation(res) {
  const lat = res.coords.latitude;
  const lon = res.coords.longitude;
  getTemp(lat, lon);
}

async function getTemp(lat = 0, lon = 0, city = "Sydney") {
  const apiKey = "6aab845187b969adecd7c1a5012a8254";

  const apiUrl = !lat
    ? `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`
    : `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;

  await axios.get(apiUrl).then(
    (res) => {
      const temp = res.data.main.temp;
      const des = res.data.weather[0].description;
      const ws = res.data.wind.speed;
      const h = res.data.wind.speed;

      let element = document.getElementById("temperature");
      let link = document.getElementById("convert");
      let wind = document.getElementById("wind-speed");
      let description = document.getElementById("weather-des");

      element.innerText = Math.round(temp);
      link.innerText = "Convert to Fahrenheit";
      description.innerText = des;
      wind.innerText = `Humidity: ${h}, wind: ${ws}km/h`;
      getForecast(apiKey, res.data.coord.lat, res.data.coord.lon);
    },
    (err) => err
  );
}

async function getForecast(apiKey, lat, lon) {
  const forecastUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;

  const days = document.getElementsByClassName("WeatherForecastPreview");

  const week = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  await axios.get(forecastUrl).then(
    (res) => {
      console.log(res);
      let i = 0;
      for (let day of days) {
        let dayName = day.getElementsByClassName("forecast-time")[0];
        let max = day.getElementsByClassName("forecast-temperature-max")[0];
        let min = day.getElementsByClassName("forecast-temperature-min")[0];

        dayName.innerText =
          week[
            week.indexOf(
              new Date()
                .toLocaleDateString("en-EN", { weekday: "long" })
                .slice(0, 3)
            ) + i
          ];
        max.innerText = res.data.daily[i].temp.max.toString() + "°";
        min.innerText = res.data.daily[i].temp.min.toString() + "°";
        if (i <= 5) {
          i = i + 1;
        }
      }
    },
    (err) => err
  );
}

const current = document.getElementById("current");
current.addEventListener(
  "click",
  () => navigator.geolocation.getCurrentPosition(getLocation),
  false
);

const button = document.getElementById("searchButton");
button.addEventListener(
  "click",
  function () {
    let city = document.getElementById("cname");
    let element = document.getElementById("city-name");
    if (city && city.value) {
      element.innerHTML = city.value;
      getTemp(0, 0, city.value);
    } else {
      console.log("Sorry, there is no such location");
    }
  },
  false
);

const link = document.getElementById("convert");
link.addEventListener(
  "click",
  function () {
    let temp = document.getElementById("temperature");
    if (link.innerText === "Convert to Fahrenheit") {
      temp.innerText = (+temp.innerText * 9) / 5 + 32;
      link.innerText = "Convert to Celsius";
    } else {
      temp.innerText = ((+temp.innerText - 32) * 5) / 9;
      link.innerText = "Convert to Fahrenheit";
    }
  },
  false
);

setDate();
